import { ButtonBase, Grid, Typography } from "@mui/material";
import logo from "../../Recursos/logo.svg";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import { NavLink } from 'react-router-dom';


const BarraPc = () => {
    const { sCell, masSM } = useResponsive()
    const paginas = [
        { nombre: 'Inicio', ruta: '/' },
        { nombre: 'Servicios', ruta: '/servicios/' },
        { nombre: 'Nosotros', ruta: '/nosotros/' },
        { nombre: 'Blog', ruta: '/blogs/' },
        { nombre: 'Contacto', ruta: '/contacto/' },
    ];

    return (

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
                position='absolute'
                sx={{
                    backgroundColor: 'white',
                    position: 'fixed',
                    width: '100%',
                    top: 0,
                    zIndex: 1300,
                    pt: 0,
                    pb: 1,
                    borderBottom: '1px solid #AEAEAE',
                }}>

                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{ maxWidth: "1400px", px: 3, pt: 1 }}>

                    {/* Logo */}
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 3 }}>
                        <a href="/" aria-label="Ir al inicio">
                            <img
                                src={logo}
                                alt="Logo de la empresa"
                                width={'100%'}
                                height={'auto'}
                                style={{ cursor: 'pointer' }}
                            />
                        </a>
                    </Grid>

                    {/* Menú con ul/li */}
                    <Grid
                        container
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                        size={{ xs: 12, sm: 12, md: 9 }}
                        sx={{ gap: 2 }}>

                        <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0 }}>
                            {paginas.map(pagina => (
                                <li key={pagina.nombre} style={{ margin: '0 8px' }}>
                                    <ButtonBase
                                        component={NavLink}
                                        to={pagina.ruta}
                                        aria-label={`Ir a ${pagina.nombre}`}
                                        sx={{
                                            px: 1,
                                            "&.active span": {
                                                color: "#7D848C",
                                                fontWeight: 700,
                                            },
                                            "&:hover span": {
                                                color: "#7D848C",
                                            }
                                        }}>
                                        <Typography
                                            component="span"
                                            sx={{
                                                color: '#223B59',
                                                fontSize: 16,
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                textDecoration: 'none'
                                            }}
                                        >
                                            {pagina.nombre}
                                        </Typography>
                                    </ButtonBase>
                                </li>
                            ))}

                        </ul>
                    </Grid>
                </Grid>
            </Grid>
    )
}
export default BarraPc;
